export const viewportName = () => {
  let intViewportWidth = window.innerWidth

  if (intViewportWidth < 768) {
    return 'mobile'
  } else {
    return 'computer'
  }
}

export const doPost = (url, body, successCb) => {
  fetch(url + '.json', {
    headers: {
      "X-CSRF-Token": document.querySelector("[name='csrf-token']")?.content,
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: body
  }).then(res => {
    successCb(res)
  })
}

export const doPut = (url, body, successCb) => {
  fetch(url + '.json', {
    headers: {
      "X-CSRF-Token": document.querySelector("[name='csrf-token']")?.content,
    },
    method: 'PUT',
    body: body
  }).then(res => {
    successCb(res)
  })
}

export const doDelete = (url, body, successCb) => {
  fetch(url + '.json', {
    headers: {
      "X-CSRF-Token": document.querySelector("[name='csrf-token']")?.content,
    },
    method: 'DELETE',
    body: body
  }).then(res => {
    successCb(res)
  })
}